import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
  selector: 'app-menu-style6',
  templateUrl: './menu-style6.component.html',
  styleUrls: ['./menu-style6.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MenuStyle6Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/mega-menu/menu-style6/menu-style6.component.ts